<template>
  <base-layout
    page-default-back-link="/home"
    showUserSettings="true"
    showSettings="true"
  >
    <div v-if="error !== ''" class="login_error ion-text-center">
      {{ error }}
    </div>

    <!-- Search Module  -->
    <div v-if="status == 'Search'">
      <ion-grid>
        <ion-row>
          <ion-col size="12" size-md="6">
            <ion-searchbar
              placeholder="Search"
              @ionChange="get_customers"
              debounce="1000"
              v-model="term"
            ></ion-searchbar>
          </ion-col>
          <ion-col size="12" size-md="6">
            <ion-select
            interface="popover"
            :value="searchConnection"
            @ionChange="connectionFilterFn"
            >
              <ion-select-option
                  :value="item"
                  v-for="(item, index) in connectionsList"
                  :key="index"
                  >{{ item }}
              </ion-select-option>
            </ion-select>
          </ion-col>
        </ion-row>
      </ion-grid>

      <ion-list class="results">
        <ion-item v-for="(customer, index) in customers" :key="customer.ent_id">
          <ion-grid>
            <ion-row>
              <ion-col size="12" size-md="6">
                <ion-label> Company Name: </ion-label>
                {{ customer.ent_fullname }}
              </ion-col>
              <ion-col v-if="customer.ent_email!=''" size="12" size-md="6">
                <ion-label> Email: </ion-label>
                {{ customer.ent_email }}
              </ion-col>
              <ion-col v-if="customer.ent_phone_1!='' && customer.ent_phone_2!=''" size="12" size-md="6">
                <ion-label> Phones: </ion-label>
                <span v-if="customer.ent_phone_1!=''">{{ customer.ent_phone_1 }}<br></span>
                <span v-if="customer.ent_phone_2!=''">{{ customer.ent_phone_2 }}<br></span>
              </ion-col>
<!--               <ion-col size="8" size-md="5">
                <ion-label> Name: </ion-label>
                {{ product.prod_name }}
              </ion-col>
              <ion-col size="12" size-md="4">
                <ion-label>by</ion-label>
                {{ product.ent_fullname }}
              </ion-col> -->
            </ion-row>
            <ion-row>
<!--               <ion-col size="12" size-md="8">
                <ion-label> Dimension: </ion-label>
                {{ product.pitem_dimension }}
                <br /><br />
                <ion-label> Price: </ion-label>
                ${{ product.pitem_price_designer }} / {{ product.pitem_unit }}
              </ion-col> -->
              <ion-col size="12" class="ion-text-right">
                <ion-button size="small" @click="show_customer(index)">
                  <ion-icon :icon="eyeOutline"></ion-icon>&nbsp;Open
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-item>
      </ion-list>


      <div v-if="show_scroll">
        <ion-infinite-scroll
          @ionInfinite="loadData($event, true)"
          threshold="100px"
          id="infinite-scroll"
          :disabled="false"
        >
          <ion-infinite-scroll-content
            loading-spinner="bubbles"
            loading-text="Loading more data..."
          >
          </ion-infinite-scroll-content>
        </ion-infinite-scroll>
      </div>
    </div>

    <!-- View Customer's Information Module  -->
    <div v-if="status == 'Customer_Information'">
      <br>
      <div class="ion-text-right">
        <ion-button size="small" @click="back_to_search(item)">Back</ion-button>
      </div>
      <br>
      <div class="information">
        <ion-grid>
          <ion-row>
            <ion-col size="12">
              <div style="display: flex; flex-wrap: wrap">
                <ion-col size="12" size-md="6">
                  <ion-label>Company Name: </ion-label><br />
                  {{ selected_customer.ent_fullname }}
                </ion-col>
                <ion-col v-if="selected_customer.ent_email!=''" size="12" size-md="6">
                  <ion-label> Email: </ion-label>
                  {{ selected_customer.ent_email }}
                </ion-col>
                <ion-col v-if="selected_customer.ent_phone_1!='' && selected_customer.ent_phone_2!=''" size="12" size-md="6">
                  <ion-label> Phones: </ion-label>
                  <span v-if="selected_customer.ent_phone_1!=''">{{ selected_customer.ent_phone_1 }}<br></span>
                  <span v-if="selected_customer.ent_phone_2!=''">{{ selected_customer.ent_phone_2 }}<br></span>
                </ion-col>
              </div>
            </ion-col>
          </ion-row>
          <hr>
          <ion-row style="margin-bottom:10px;border-left: 10px solid red;" v-for="item in selected_customer.contacts" :key="item.con_id">
            <ion-col size="12" size-md="6">
              <div style="display: flex; flex-wrap: wrap">
                <ion-col size="12" >
                  <ion-label>Name: </ion-label><br />
                  <span>{{ item.con_first_name }}&nbsp;{{ item.con_last_name }}</span>
                </ion-col>
                <ion-col size="12" style="padding:0px;">
                  <div style="display: flex; flex-wrap: wrap;padding:0px;">
                    <ion-col v-if="item.con_email!=''" size="12" size-md="6">
                      <ion-label>Email: </ion-label><br>
                      {{ item.con_email }}
                    </ion-col>
                    <ion-col v-if="item.con_phone_1!='' && item.con_phone_2!=''" size="12" size-md="6">
                      <ion-label>Office Phones: </ion-label><br>
                      <span v-if="item.con_phone_1!=''">{{ item.con_phone_1 }}<br></span>
                      <span v-if="item.con_phone_2!=''">{{ item.con_phone_2 }}<br></span>
                    </ion-col>
                    <ion-col v-if="item.con_mobile!=''" size="12" size-md="6">
                      <ion-label>Mobile Phone: </ion-label>
                      {{ item.con_mobile }}
                    </ion-col>
                  </div>
                </ion-col>
              </div>
            </ion-col>
          </ion-row>
          <hr>
          <ion-row style="margin-bottom:10px;border-left: 10px solid red;" v-for="item in selected_customer.addresses" :key="item.enta_id">
            <ion-col size="12" size-md="6">
              <div style="display: flex; flex-wrap: wrap">
                <ion-col size="12" >
                  <ion-label>Attention: </ion-label>
                  <span>{{ item.enta_person_in_charge }}</span>
                </ion-col>
                <ion-col size="12">
                  <ion-label>Address: </ion-label><br>
                  <span v-if="item.enta_address_1!=''" size="12">
                    {{ item.enta_address_1 }}<br>
                  </span>
                  <span v-if="item.enta_address_2!=''">
                    {{ item.enta_address_2 }}<br>
                  </span>
                  <span v-if="item.enta_city!=''" size="12">
                    {{ item.enta_city }}<br>
                  </span>
                  <span v-if="item.enta_postcode!=''" size="6">
                    {{ item.enta_postcode }},
                  </span>
                  <span v-if="item.zone_name!=''" size="6">
                    {{ item.zone_name }}<br>
                  </span>
                  <span v-if="item.cou_name!=''" size="12">
                    {{ item.cou_name }}<br>
                  </span>
                </ion-col>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </div>
  </base-layout>
</template>

<script>
import {
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonItem,
  IonLabel,
  IonList,
  IonGrid,
  IonRow,
  IonCol,
  IonButton,
  IonIcon,
  IonSearchbar,
  IonSelect,
  IonSelectOption
} from "@ionic/vue";
import { searchOutline, eyeOutline } from "ionicons/icons";

export default {
  components: {
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonItem,
    IonLabel,
    IonList,
    IonGrid,
    IonRow,
    IonCol,
    IonButton,
    IonIcon,
    IonSearchbar,
    IonSelect,
    IonSelectOption
  },

  data() {
    return {
      status: "Search",

      searchConnection: "",
      connectionsList: [],
      connectionsListWithCode: [],

      term: "",
      limit: 20,
      offset: 0,
      show_scroll: false,

      error: "",
      customers: [],
      selected_customer: "",

      searchOutline,
      eyeOutline,
    };
  },

  methods: {
    get_customers() {
      this.customers = []; // empty result
      (this.limit = 20), (this.offset = 0), (this.show_scroll = true);
      this.loadData(this.$event, false);
    },

    connectionFilterFn({ detail }) {
      console.log(detail);
      this.searchConnection = detail.value;
      this.customers = []; // empty result
      this.limit = 20;
      this.offset = 0;
      this.show_scroll = true;
      this.loadData(this.$event, false);
    },

    async loadData(event, call_event) {
      console.log("Load data");

      let conn_id = 0;
      for (let i = 0; i < this.connectionsListWithCode.length; i++) {
        if (this.connectionsListWithCode[i].conn_name == this.searchConnection) {
          conn_id = this.connectionsListWithCode[i].conn_id;
        }
      }

      await this.$store.dispatch("customers/customers_search", {
        term: this.term,
        limit: this.limit,
        offset: this.offset,
        conn_id: conn_id
      });
      this.offset += this.limit;
      var error = this.$store.getters["customers/getRequestError"];

      if (error != "") {
        this.error = error;
      } else {
        let received_customers = this.$store.getters["customers/getCustomers"];
        for (let i = 0; i < received_customers.length; i++) {
          this.customers.push(received_customers[i]);
        }

        if (received_customers.length < this.limit) {
          this.show_scroll = false;
        }

        this.error = "";
      }

      if (call_event) event.target.complete();
    },

    show_customer(index) {
      this.selected_customer = this.customers[index];
      console.log(this.selected_customer);
      this.status = "Customer_Information";
    },

    back_to_search() {
      this.status = "Search";
    },
  },

  ionViewDidEnter() {
    let ref = this;

    this.connectionsList = []; // empty the list with connections

    this.$store.dispatch("various/connections").then( response => {
        if(response.data.success){

          console.log(response.data.results);
          ref.connectionsListWithCode = response.data.results;
          for(let i=0; i<ref.connectionsListWithCode.length; i++){
            ref.connectionsList.push(ref.connectionsListWithCode[i].conn_name);
          }
          ref.searchConnection = ref.connectionsListWithCode[0].conn_name
        } else {
          ref.error = response.message;
        }
    }, request_error => {
        ref.error = request_error;
    })
  }

};
</script>

<style lang="scss" scoped>
.results {
  .conf-name {
    color: #000;
  }

  ion-row {
    background: #ffffff;
    /*     margin-bottom: 10px; */
    padding: 10px;
    border-left: 10px solid #226391;
    height: auto;
  }

  .no-date {
    font-style: italic;
  }

  a {
    text-decoration: none;
  }

  ion-grid {
    height: auto;
  }

  ion-item {
    border: none;
    padding: 0px;
  }

  .item-native {
    padding: 0px;
    padding-inline: 0px;
  }

  .item-inner {
    padding: 0px;
    padding-inline: 0px;
    border: none;
  }

  ion-label {
    font-size: 0.8em;
    font-weight: bold;
    color: #444;
  }
}

.information {
  font-size: 0.9em;

  .conf-name {
    color: #000;
  }

  ion-row {
    background: #ffffff;
    /*     margin-bottom: 10px; */
    padding: 10px;
    border-left: 10px solid #079602;
    height: auto;
  }

  .no-date {
    font-style: italic;
  }

  a {
    text-decoration: none;
  }

  ion-grid {
    height: auto;
  }

  ion-item {
    border: none;
  }

  ion-label {
    font-size: 0.8em;
    font-weight: bold;
    color: #444;
  }
}

.login_error {
  color: red;
  font-size: 15px;
}
</style>